import TextEditor from "./textEditor";
import textEditorReducer, {initialState} from "./textEditorSlice";

export {textEditorReducer, initialState};
export default TextEditor;